<template>
  <div>
    <p>Hola Mundo</p>
    <b-button>

    </b-button>
  </div>
</template>

<script>
export default {
 name:"DescargaReporte",
 data(){
    return{

    }
 },
 created(){
    console.log(this.$route.query.test)
    window.open("https://storage.cloud.google.com/bucket-services/FilesXlsxSS/ReporteOSCProveedor_10_11_2022a10_12_2022-20221210161053.xlsx")
 },
 methods:{
    downloadReport() {
        console.log('hi')
    }
 }
}
</script>

<style>

</style>